/*
  useDimensions.js
*/

// Npm.
import { useState, useLayoutEffect } from 'react';

// If we are in IE11, we need to use a polyfill.
// Either choose the polyfill or the regular one here depending on support.
import _ResizeObserver from 'resize-observer-polyfill';
const UseResizeObserver = typeof ResizeObserver !== 'undefined' ? ResizeObserver : _ResizeObserver;

/**
 * Helper to get the width and height 
 */
function getElementDimesions(el) {
  const rect = el.getBoundingClientRect();
  return {
    width: rect.width,
    height: rect.height,
  };
}

/**
 * Helper to get the width and height from a resize observer entry.
 */
function getEntrySize(entry) {
  if (entry.contentRect) {
    return {
      width: entry.contentRect.width,
      height: entry.contentRect.height,
    };
  }
}

/**
 * Hook to return the dimensions of the associated element.
 */
export default function useDimensions(ref) {

  const [value, setValue] = useState({ width: 0, height: 0 });

  useLayoutEffect(() => {
    const el = ref.current;
    if (el) {

      function setValueIfDiffers(next) {
        if (next) {
          setValue(v => v.width !== next.width || v.height !== next.height ? next : v);
        }
      }

      setValueIfDiffers(getElementDimesions(el));

      const resizeObserver = new UseResizeObserver((entries) => {
        for (const entry of entries) {
          setValueIfDiffers(getEntrySize(entry));
        }
      });

      resizeObserver.observe(el);

      return () => {
        resizeObserver.disconnect();
      };

    }
  }, [ref]);

  return value;

}
